import { Link } from "react-router-dom";
import { Home as HomeIcon, ArrowRight, Search } from "lucide-react";
import PageHeader from "../components/PageHeader";
import SEO from "../components/SEO";

const QUICK_LINKS = [
    { t: "Home Tuition · Cities", l: [
        ["Jabalpur (HQ)", "/jabalpur"],
        ["Bhopal", "/bhopal"],
        ["Nagpur", "/nagpur"],
        ["Mumbai", "/home-tuition-mumbai"],
        ["Delhi NCR", "/home-tuition-delhi"],
        ["Bangalore", "/home-tuition-bangalore"],
    ]},
    { t: "Online Tuition · Countries", l: [
        ["🇺🇸 USA", "/online-tuition-usa"],
        ["🇬🇧 UK", "/online-tuition-uk"],
        ["🇦🇺 Australia", "/online-tuition-australia"],
        ["🇨🇦 Canada", "/online-tuition-canada"],
        ["Foreign Students Hub", "/foreign-students"],
        ["Online Classes (India)", "/online-classes"],
    ]},
    { t: "Useful Links", l: [
        ["About Us", "/about"],
        ["Courses & Boards", "/courses"],
        ["Blog", "/blog"],
        ["Free Demo Registration", "/register"],
        ["FAQs", "/faqs"],
        ["Contact", "/contact"],
    ]},
];

export default function NotFound() {
    return (
        <div data-testid="not-found-page">
            <SEO title="404 — Page Not Found" description="The page you're looking for couldn't be found. Try the homepage or pick a city below." path="/404" noindex />
            <PageHeader
                eyebrow="404 · Looks like this page took a study break"
                title="Page not found — but your child's tutor is."
                subtitle="The page you're looking for doesn't exist or has been moved. Try the homepage, or jump to a popular section below."
            >
                <div className="flex flex-wrap gap-3">
                    <Link to="/" data-testid="404-home" className="inline-flex items-center gap-2 bg-amber-500 text-[#0F172A] font-semibold px-5 py-3 rounded-lg hover:bg-amber-400">
                        <HomeIcon className="w-4 h-4" /> Back to Home
                    </Link>
                    <Link to="/register" data-testid="404-demo" className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur text-white font-semibold px-5 py-3 rounded-lg hover:bg-white/15">
                        Book a Free Demo <ArrowRight className="w-4 h-4" />
                    </Link>
                </div>
            </PageHeader>
            <section className="py-16 bg-white">
                <div className="max-w-6xl mx-auto px-6 lg:px-8">
                    <div className="text-center mb-10">
                        <Search className="w-10 h-10 text-slate-300 mx-auto mb-3" />
                        <h2 className="font-heading text-2xl sm:text-3xl font-bold text-[#0F172A]">Where would you like to go?</h2>
                        <p className="text-sm text-slate-500 mt-1">A quick directory of our most-visited pages.</p>
                    </div>
                    <div className="grid md:grid-cols-3 gap-6">
                        {QUICK_LINKS.map((g) => (
                            <div key={g.t} className="bg-[#F8FAFC] rounded-2xl border border-slate-200 p-6">
                                <h3 className="font-heading font-semibold text-[#0F172A] mb-3 text-sm uppercase tracking-[0.15em]">{g.t}</h3>
                                <ul className="space-y-1">
                                    {g.l.map(([n, h]) => (
                                        <li key={h}>
                                            <Link to={h} className="flex items-center justify-between p-2 rounded-lg hover:bg-white text-sm text-slate-700 hover:text-[#1E3A8A] group transition-colors">
                                                <span>{n}</span>
                                                <ArrowRight className="w-3.5 h-3.5 text-slate-300 group-hover:text-[#1E3A8A] group-hover:translate-x-0.5 transition-all" />
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
